"use client";

import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2327" id="call-to-action" className="relative bg-background text-foreground min-h-screen w-full overflow-hidden">
      {}
      <div className="relative flex flex-col md:flex-row min-h-screen">
        {}
        <div className="relative w-full md:w-1/2 h-[50vh] md:h-screen overflow-hidden group">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_facility_exterior.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_facility_exterior.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_facility_exterior.png-wvc-sizes" alt="Our industrial facility - precision engineering and manufacturing floor" loading="eager" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-105" style={{
          filter: "sepia(0.15) saturate(1.05) brightness(0.85)"
        }} />
          <div className="absolute inset-0" style={{
          background: "linear-gradient(180deg, hsla(216, 50%, 12%, 0.45) 0%, hsla(216, 50%, 12%, 0.55) 50%, hsla(216, 50%, 12%, 0.75) 100%)"
        }} />

          {}
          <div className="absolute bottom-8 left-6 md:left-10 z-10">
            <div className="text-xs md:text-sm tracking-[0.3em] font-default" style={{
            color: "hsl(45 68% 47%)"
          }}>
              — I. MANUFACTURING
            </div>
            <div className="mt-3 h-px w-16" style={{
            backgroundColor: "hsl(45 68% 47%)",
            opacity: 0.7
          }} />
          </div>
        </div>

        {}
        <div className="relative w-full md:w-1/2 h-[50vh] md:h-screen overflow-hidden group">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/precision_engineering_lab.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/precision_engineering_lab.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/precision_engineering_lab.webp-wvc-sizes" alt="Our precision engineering lab - advanced testing and quality control" loading="eager" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[2000ms] ease-out group-hover:scale-105" style={{
          filter: "sepia(0.2) saturate(1.1) brightness(0.75) hue-rotate(-8deg)"
        }} />
          <div className="absolute inset-0" style={{
          background: "linear-gradient(180deg, hsla(216, 50%, 12%, 0.45) 0%, hsla(216, 50%, 12%, 0.6) 50%, hsla(216, 50%, 12%, 0.8) 100%)"
        }} />

          {}
          <div className="absolute bottom-8 right-6 md:right-10 z-10 text-right">
            <div className="text-xs md:text-sm tracking-[0.3em] font-default" style={{
            color: "hsl(45 68% 47%)"
          }}>
              — II. ENGINEERING
            </div>
            <div className="mt-3 h-px w-16 ml-auto" style={{
            backgroundColor: "hsl(45 68% 47%)",
            opacity: 0.7
          }} />
          </div>
        </div>

        {}
        <div className="hidden md:block absolute top-0 bottom-0 left-1/2 -translate-x-1/2 z-10 pointer-events-none" style={{
        width: "1px",
        backgroundColor: "hsl(45 68% 47%)",
        opacity: 0.6
      }} />

        {}
        

        {}
        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center">
          <span className="font-default text-[10px] tracking-[0.35em] mb-3" style={{
          color: "hsl(40 21% 89%)",
          opacity: 0.85,
          animation: "oak-pulse 2.8s ease-in-out infinite"
        }}>
            SCROLL
          </span>
          <div className="w-px h-12 md:h-16" style={{
          background: "linear-gradient(to bottom, hsl(45 68% 47%) 0%, hsla(45, 68%, 47%, 0) 100%)"
        }} />
          <ChevronDown className="w-3 h-3 mt-1" style={{
          color: "hsl(45 68% 47%)",
          opacity: 0.6
        }} />
        </div>
      </div>

      <style>{`
        @keyframes oak-pulse {
          0%, 100% { opacity: 0.5; }
          50% { opacity: 1; }
        }
      `}</style>
    </section>;
}